var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _vm.filtersDisabled != true
      ? _c(
          "div",
          { staticClass: "collection-sidebar" },
          [
            _c("collection-filters", {
              attrs: { tags: _vm.tags, filters: _vm.filters }
            })
          ],
          1
        )
      : _vm._e(),
    _vm.relatedCollections.length > 0
      ? _c(
          "div",
          { staticClass: "related-collections" },
          [
            _c("h4", [_vm._v("Related Collections")]),
            _vm._l(_vm.relatedCollections, function(relatedCollection, index) {
              return _c(
                "a",
                {
                  key: index,
                  staticClass: "related-collection",
                  attrs: { href: relatedCollection.url }
                },
                [
                  _c("span", { staticClass: "tag-text" }, [
                    _vm._v(_vm._s(relatedCollection.text))
                  ])
                ]
              )
            })
          ],
          2
        )
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }